import React, { useEffect, useRef, useState } from "react";
import styles from "./reveal.module.scss";

interface RevealProps {
  children: React.ReactNode;
  className?: string;
  delayMs?: number;
  variant?: "fade" | "fade-up" | "fade-right" | "fade-left";
}

const Reveal: React.FC<RevealProps> = ({ children, className, delayMs = 0, variant = "fade-up" }) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => setVisible(true), delayMs);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [delayMs]);

  const classes = [styles.reveal, styles[variant], visible ? styles.visible : "", className || ""].join(" ").trim();

  return (
    <div ref={ref} className={classes}>
      {children}
    </div>
  );
};

export default Reveal;
